import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb, FileSearch, Cpu, Layers } from 'lucide-react';
import { services } from '../data/mock';

const icons = {
  1: Lightbulb,
  2: FileSearch,
  3: Cpu,
  4: Layers
};

const ServicesSection = () => {
  return (
    <section className="section section-alt" id="services">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="caption mb-4 inline-block" style={{ color: 'var(--accent-primary)' }}>
            What We Do
          </span>
          <h2 className="heading-1 mb-4">Our Services</h2>
          <p className="body-large max-w-2xl mx-auto">
            We provide a wide range of artificial intelligence services tailored to your needs.
          </p>
        </motion.div>

        <div className="service-grid">
          {services.map((service, index) => {
            const Icon = icons[service.id];
            return (
              <motion.div
                key={service.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="card group"
              >
                <div className="icon-container mb-5 group-hover:scale-110 transition-transform">
                  <Icon size={22} />
                </div>
                <h3 className="heading-3 mb-3">{service.title}</h3>
                <p className="body-small">
                  {service.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
